import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import styles from './Link.module.scss';

const NormalLink = ({ children, className, ...rest }) => (
    <Link className={classnames(styles.link, className)} {...rest}>
        {children}
    </Link>
);
NormalLink.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};
NormalLink.defaultProps = {
    children: null,
    className: '',
};

export default NormalLink;
